import { render, staticRenderFns } from "./TextSmall.vue?vue&type=template&id=2040b72a&"
import script from "./TextSmall.vue?vue&type=script&lang=js&"
export * from "./TextSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports